import emptyState from "./emptyState";
import { actionTypes } from "./actions";
import { immutableSet } from "../../../utils/immutable";
import { compose } from "redux";

import { STATE_IDENTIFIER } from "./constants";
import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";

const {
  REPORTS,
  REPORTS_LOADER,
  SELECTED_REPORT,
  RESPONSE_STATE,
  VALUE,
  CAMPAIGN_NAMES,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.MODIFY_SELECTED_REPORT]: (state: any, action: any) =>
    immutableSet([SELECTED_REPORT], action.payload, state),

  [actionTypes.REPORTS_REQUEST]: (state: any, action: any) =>
    immutableSet([REPORTS_LOADER], true, state),
  [actionTypes.REPORTS_REQUEST_SUCCESS]: (state: any, action: any) => {
    const payloadTemp = action.payload;
    return compose(
      immutableSet([REPORTS], payloadTemp),
      immutableSet([REPORTS_LOADER], false)
    )(state);
  },
  [actionTypes.REPORTS_REQUEST_FAILURE]: (
    state: any,
    action: { type: string; payload: any }
  ) => {
    return compose(
      immutableSet([REPORTS], []),
      immutableSet([REPORTS_LOADER], false)
    )(state);
  },

  [actionTypes.REPORT_GENERATE]: (state: any, action: any) =>
    immutableSet([RESPONSE_STATE], IResponseState.PENDING, state),

  [actionTypes.REPORT_GENERATE_SUCCESS]: (state: any, action: any) =>
    immutableSet([RESPONSE_STATE], IResponseState.SUCCESS, state),

  [actionTypes.REPORT_GENERATE_FAILURE]: (state: any, action: any) =>
    immutableSet([RESPONSE_STATE], IResponseState.ERROR, state),

  [actionTypes.REPORT_VALUE]: (
    state: any,
    action: { type: string; payload: any }
  ) => {
    let TempArray = [...state.Value];

    TempArray.forEach((input) => {
      if (input.id === action.payload.id) {
        input.value = action.payload.value;
      }
    });
    return compose(immutableSet([VALUE], TempArray, state));
  },

  [actionTypes.ADD_REPORT_INPUT]: (
    state: any,
    action: { type: string; payload: any }
  ) => {
    let TempArray = [...state.Value];

    TempArray.push({
      value: action.payload.value,
      id: action.payload.id,
      parameter: action.payload.parameter,
      label: action.payload.label,
      property: action.payload.property,
    });
    return compose(immutableSet([VALUE], TempArray, state));
  },

  [actionTypes.REPORTS_CAMPAIGNS_NAMES_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const mappedResponse = [];
    for (let i = 0; i < action.payload.length; i++) {
      mappedResponse.push({ id: i, value: action.payload[i] });
    }
    return immutableSet([CAMPAIGN_NAMES], mappedResponse, state);
  },

  [actionTypes.REPORTS_CAMPAIGNS_NAMES_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([CAMPAIGN_NAMES], [], state),

  [actionTypes.REPORT_RESET_STATE]: (state: any, action: any) =>
    immutableSet([VALUE], [], state),
};
export default function communicationReducer(state = emptyState, action: any) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    action.payload.location.pathname === "/welcome"
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
